export async function login(username, password) {
  return (
    fetch(`${process.env.SERVER_URL}/login/password`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    })
      // .then((res) => res.json())
      .then((res) => {
        console.log('res', res);
        if (res.json) {
          try {
            res.json().then((data) => {
              console.log('login json', data);
            });
          } catch (e) {
            console.log('json error', e);
          }
        }
        if (res && res.url.includes('/login')) {
          throw 'Incorrect login';
        } else {
          return 'success';
        }
      })
  );
}

export async function register(data) {
  const { username, password, name, registerKey } = data;
  return fetch(`${process.env.SERVER_URL}/register`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password, name, registerKey }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res && res.error) {
        throw res;
      }
    });
}

export async function logout() {
  return fetch(`${process.env.SERVER_URL}/logout`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
}
